import React, { useState } from "react";
import SchoolAdminDetails from "./SchoolAdminDetails";
import SchoolAdminHome from "./SchoolAdminHome";
import SchoolDocs from "./SchoolDocs";
import SchoolMigration from "./SchoolMigration";
import RazorpayKyc from "./RazorpayKyc";

const SwitchSchool = () => {
  const [step, setStep] = useState(1);

  function switchTab() {
    switch (step) {
      case 1:
        return (
          <div>
            <SchoolAdminHome />
          </div>
        );

      case 2:
        return (
          <div>
            <SchoolAdminDetails />
          </div>
        );
      case 3:
        return (
          <div>
            <SchoolDocs />
          </div>
        );
      case 4:
        return (
          <div>
            <SchoolMigration />
          </div>
        );
      case 5:
        return (
          <div>
            <RazorpayKyc />
          </div>
        );

      default:
        return (
          <div>
            <SchoolAdminHome />
          </div>
        );
    }
  }

  return (
    <>
      <div className="p-8">
        <div className="grid grid-cols-5 bg-white rounded-lg ">
          <div
            onClick={() => setStep(1)}
            className={`iskool-tab-item ${
              step === 1 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Admin</div>
          </div>
          <div
            onClick={() => setStep(2)}
            className={`iskool-tab-item ${
              step === 2 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">School Details</div>
          </div>
          <div
            onClick={() => setStep(3)}
            className={`iskool-tab-item ${
              step === 3 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Docs</div>
          </div>
          <div
            onClick={() => setStep(4)}
            className={`iskool-tab-item ${
              step === 4 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Migration</div>
          </div>
          <div
            onClick={() => setStep(5)}
            className={`iskool-tab-item ${
              step === 5 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Razorpay KYC</div>
          </div>
        </div>
        {/* ------------------------------------------------------------------------------------------- */}
        <div>
          <div>{switchTab()}</div>
        </div>
      </div>
    </>
  );
};

export default SwitchSchool;
